export enum MessageToastType {
    INFO = 1,
    CANCELABLE = 2,
    ERROR = 3
}
